export enum OneTimeProductCodes {
    Breathing = 'breathing',
    Meditation = 'meditation',
    NutritionDiet = 'nutrition_diet',
    NutritionFasting = 'nutrition_fasting',
    HabitBuilding = 'habit_building',
    Motivation = 'motivation',
    NutritionDietMeditationBreathing = 'nutrition_diet_meditation_breathing',
    MotivationMeditationBreathing = 'motivation_meditation_breathing',
    NutritionDietMeditationBreathingV2 = 'nutrition_diet_meditation_breathing_v2',
    HabitBuildingMeditationBreathing = 'habit_building_meditation_breathing',
    NutritionDietNutritionFasting = 'nutrition_diet_nutrition_fasting',
    MeditationBreathing = 'meditation_breathing',
    MotivationHabitBuilding = 'motivation_habit_building',
    NutritionDietHabitBuilding = 'nutrition_diet_habit_building',
    NutritionFastingHabitBuilding = 'nutrition_fasting_habit_building',
    MotivationMeditation = 'motivation_meditation',
}

// Used only for subscription detection and title translations (e.g. cards, lifetime upsells)
export enum SubscriptionProductCodes {
    AppFullAccess = 'app_full_access',
    Main = 'main',
    face = 'face',
    Fatburn = 'fatburn',
    FatburnFace = 'fatburn_face',
    WorkoutBuilder = 'workout_builder',
    Highintense = 'highintense',
    Shoulders = 'shoulders',
    Pilates = 'pilates',
    Back = 'back',
    Weightloss = 'weightloss',
    Sevenintense = 'sevenintense',
    Hips = 'hips',
    Chair = 'chair',
    Wall = 'wall',
    VipSupport = 'vip_support',
    Sevenmin = 'sevenmin',
    Belly = 'belly',
    BellySofa = 'belly_sofa',
    Sofa = 'sofa',
    BellySevenmin = 'belly_sevenmin',
    CoreUpgrade = 'core__upgrade',
    CoreNutritionMeditationBreathing = 'core__nutrition__meditation__breathing',
    CoreNutrition = 'core__nutrition',
    CoreMeditationBreathing = 'core__meditation__breathing',
}

// Should be used in the main business logic
export enum SubscriptionProductTypes {
    MainSubscription = 'main_subscription',
    UpgradeSubscription = 'upgrade_subscription',
    UpsellSubscription = 'upsell_subscription',
    UpsellOnetime = 'upsell_onetime',
}

export interface Product {
    amount: number;
    currency: string;
    id: string;
    name: string;
    payment_action: string;
    subscription_period: number;
    subscription_trial_period: number;
    started_from: string;
    trial: boolean;
    trial_period: number;
    trial_amount: number;
    trial_currency: string;
}

export interface IUpcomingProduct {
    started_from: string;
    amount: number;
    currency: string;
    subscription_period: number;
    id: string;
    name: string;
    product_id: string;
}

export interface IProductWF {
    amount: number;
    currency: string;
    id: string;
    name: string;
    payment_action: string;
    started_from: string;
    trial: boolean;
    trial_period: number | null;
    trial_amount: number | null;
    trial_currency: string | null;
}

export interface IUpcomingProductWF {
    id: string;
    started_from: string;
    amount: number;
    currency: string;
    subscription_period: number;
}
